import { render, staticRenderFns } from "./RightPanel.vue?vue&type=template&id=75b2cb17&scoped=true&"
var script = {}
import style0 from "./RightPanel.vue?vue&type=style&index=0&id=75b2cb17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b2cb17",
  null
  
)

export default component.exports